export default __webpack_public_path__ + "static/media/repair-3.66d64e04.jpg";